<template>
  <v-container fluid>
    <gg-card>
      <gg-card-text>
        <v-row>
          <v-col cols="12">
            Current flow is not supported
          </v-col>
        </v-row>
      </gg-card-text>
    </gg-card>
  </v-container>
</template>

<script>
export default {
  name: 'UnknownFlow'
}
</script>
